// extracted by mini-css-extract-plugin
export default {"wrapper":"App_1_wrapper__uyOst","App":"App_1_App__1NaXR","h1":"App_1_h1__hUDlt"};